import {createSelector, MemoizedSelector, MemoizedSelectorWithProps} from '@ngrx/store';

import {MasterDataModuleState, PRODUCTS_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';
import {State} from '../reducers/products.reducers';
import {generateBaseSelectors} from '../../../shared/utilities/selector.utilities';
import {Product} from '../../models';
import {ApplicationState} from '../../../application-state/store';

type BaseType = Product;
type StateType = State;
const NAMESPACE = PRODUCTS_FEATURE_KEY;
const MODULE_STATE_SELECT = selectMasterDataModuleState;

export const {
  sState,
  isLoading,
  isLoaded,
  sEntities,
  sList,
  sById,
  sByIri
}: {
  isLoading: MemoizedSelector<ApplicationState, boolean>;
  sById: (id) => MemoizedSelector<ApplicationState, any>;
  sByIri: MemoizedSelectorWithProps<ApplicationState, { readonly iri?: string }, any>;
  sEntities: MemoizedSelector<ApplicationState, { [iri: string]: BaseType }>;
  sList: MemoizedSelector<ApplicationState, Array<BaseType>>;
  sState: MemoizedSelector<ApplicationState, StateType>;
  isLoaded: MemoizedSelector<ApplicationState, boolean>
} = generateBaseSelectors(MODULE_STATE_SELECT, NAMESPACE);


export const selectSearchResultsEntities = createSelector(
  sState,
  (state) => state.searchResults
);

export const selectSearchResults = createSelector(
  selectSearchResultsEntities,
  (entities) => Object.values(entities)
);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// Error States

export const selectErrors = createSelector(
  sState,
  (state) => state.errors
);

